export default "__VITE_ASSET__6nh5fQPL__"